// extracted by mini-css-extract-plugin
module.exports = {"container":"PageBackground_container__dtE31","background":"PageBackground_background__jZQxv"};